// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"626":"cfd77008","748":"d0de728e"}[chunkId] + ".chunk.js";
};